import React from 'react'

export const SVG_Cross = (props: { color?: string; height?: string; width?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '24'}
        height={props.height || '24'}
        viewBox="0 0 24 24"
    >
        <path
            fill={props.color || '#4F5B68'}
            d="M17.4 18.3h-.3c-.1 0-.2-.1-.3-.2L12 13.3l-4.8 4.8s-.2.1-.3.2c-.3.1-.6 0-.8 0-.1 0-.2-.2-.3-.4v-.5c0-.2.1-.3.2-.4l4.8-4.8L6 7.4c-.2-.2-.2-.4-.2-.6s0-.4.2-.6c.3-.3.9-.3 1.2 0L12 11l4.8-4.8c.3-.3.9-.3 1.2 0 .2.2.2.4.2.6s0 .4-.2.6l-4.8 4.8L18 17c.1.1.2.3.2.4v.5c0 .2-.2.3-.3.4-.1 0-.3.1-.5.1Z"
        />
    </svg>
)
